import { z } from 'zod';

export const registrationSchema = z.object({
  name: z.string()
    .min(3, 'Nome deve ter no mínimo 3 caracteres')
    .max(100, 'Nome muito longo'),
  
  email: z.string()
    .email('Email inválido')
    .toLowerCase(),
  
  password: z.string()
    .min(8, 'Senha deve ter no mínimo 8 caracteres')
    .regex(/[A-Z]/, 'Senha deve conter pelo menos uma letra maiúscula')
    .regex(/[0-9]/, 'Senha deve conter pelo menos um número'),
  
  birth_date: z.string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Data inválida')
    .refine(date => {
      const d = new Date(date);
      return d instanceof Date && !isNaN(d.getTime());
    }, 'Data inválida'),
  
  birth_time: z.string()
    .regex(/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/, 'Horário inválido')
    .optional(),
  
  birth_place: z.string()
    .min(3, 'Local de nascimento deve ter no mínimo 3 caracteres')
    .optional()
});

export type RegistrationData = z.infer<typeof registrationSchema>;